export class Position {
  name?: string;
  abbreviation?: string;
  department?: string;
  isSelected?: boolean;
  ranking?: number;

  constructor(
    name?: string,
    abbreviation?: string,
    department?: string,
    isSelected?: boolean,
    ranking?: number
  ) {
    this.name = name;
    this.abbreviation = abbreviation;
    this.department = department;
    this.isSelected = isSelected;
    this.ranking = ranking;
  }

  // CHECK
  // public getAbbbreviationIfLongName(maxLength: number){
  //     if(this.abbreviation && this.name.length > maxLength){
  //       return this.abbreviation;
  //     }
  //     return this.name;
  // }
}
